import { useContext, useEffect } from 'react'

import { App, ConfigProvider, theme } from 'antd'

import { DesignSystemProvider } from '../../theme/Provider'

import { registerDialogsBridge } from './dialogsBridge'
import { useDialogStyles } from './styles'

const DialogsRegistrarInner: React.FC = () => {
  const { modal } = App.useApp()
  const { token } = theme.useToken()
  const { styles } = useDialogStyles()
  const { getPrefixCls } = useContext(ConfigProvider.ConfigContext)
  const modalPrefixCls = getPrefixCls('modal')

  useEffect(() => {
    registerDialogsBridge({ modal, token, styles, modalPrefixCls })
  }, [modal, token, styles, modalPrefixCls])

  return null
}

export const DesignSystemDialogsRegistrar: React.FC = () => (
  <DesignSystemProvider>
    <DialogsRegistrarInner />
  </DesignSystemProvider>
)
